import { render, staticRenderFns } from "./HongKongTradePanel.vue?vue&type=template&id=45314090&scoped=true"
import script from "./HongKongTradePanel.vue?vue&type=script&lang=js"
export * from "./HongKongTradePanel.vue?vue&type=script&lang=js"
import style0 from "./HongKongTradePanel.vue?vue&type=style&index=0&id=45314090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45314090",
  null
  
)

export default component.exports